// extracted by mini-css-extract-plugin
module.exports = {"mobileCenter":"SectionHeaderView_mobileCenter__r7NPl","separator":"SectionHeaderView_separator__xl0WZ","separatorGrey":"SectionHeaderView_separatorGrey__c_7LS"};